import * as constants from "@/constants";
import { LayoutMenu } from "@/sx-layout/models";

export const changeLayoutMenu = (layoutMenu: LayoutMenu) => {
  return {
    type: constants.LAYOUT_APP_CHANGE_MENU,
    payload: layoutMenu,
  };
};
